import axiosInstance from './api/axiosInstance';

const notificationService = {
  async getInbox(params = {}) {
    const response = await axiosInstance.get('/notifications', { params });
    return response.data;
  },

  async getUnreadCount() {
    const response = await axiosInstance.get('/notifications/unread-count');
    return response.data;
  },

  async markRead(ids = []) {
    const response = await axiosInstance.post('/notifications/mark-read', { ids });
    return response.data;
  },

  async markAllRead() {
    const response = await axiosInstance.post('/notifications/mark-read', {});
    return response.data;
  },

  async getPreferences() {
    const response = await axiosInstance.get('/notifications/preferences');
    return response.data;
  },

  async updatePreferences(payload) {
    const response = await axiosInstance.put('/notifications/preferences', payload);
    return response.data;
  },

  async publishUpdate(payload) {
    const response = await axiosInstance.post('/notifications/admin/publish-update', payload);
    return response.data;
  },

  async getAdminHistory(params = {}) {
    const response = await axiosInstance.get('/notifications/admin/history', { params });
    return response.data;
  },
};

export default notificationService;
